const map = (product, { shopId, activeTags = [], isAdmin }) => {
    const newProduct = product.overrides
        .sort((o1, o2) => o1.priority - o2.priority)
        .reduce((acc, override) => {
        const shopMatched = override.shopIds.includes(shopId);
        const matchedTags = activeTags.filter((tag) => override.tags.includes(tag));
        if (shopMatched || matchedTags.length > 0) {
            switch (override.type) {
                case 'nameOverride':
                    if (isAdmin) {
                        return acc;
                    }
                    return Object.assign(Object.assign({}, acc), { name: override.valuesToOverride.name });
                case 'priceOverride': {
                    if (isAdmin) {
                        return acc;
                    }
                    const { valuesToOverride } = override;
                    const overriddenProduct = Object.assign(Object.assign(Object.assign({}, acc), (valuesToOverride.price ? { price: valuesToOverride.price } : {})), (valuesToOverride.priceStructure ? { priceStructure: valuesToOverride.priceStructure } : {}));
                    return overriddenProduct;
                }
                case 'isActiveOverride': {
                    if (isAdmin) {
                        return acc;
                    }
                    const { valuesToOverride } = override;
                    const overriddenProduct = Object.assign(Object.assign({}, acc), { isActive: valuesToOverride.isActive });
                    return overriddenProduct;
                }
                case 'foreignValuesOverride': {
                    if (isAdmin) {
                        return acc;
                    }
                    const { valuesToOverride } = override;
                    const { foreignIds, foreignNames } = valuesToOverride;
                    const op = Object.assign(Object.assign(Object.assign(Object.assign({}, acc), (foreignIds ? { foreignIds } : {})), (foreignNames ? { foreignNames } : {})), (foreignIds ? { options: Object.assign(Object.assign({}, product.options), { foreignIds: foreignIds }) } : {}));
                    return op;
                }
                case 'imageOverride': {
                    if (isAdmin) {
                        return acc;
                    }
                    const { valuesToOverride } = override;
                    const { link } = valuesToOverride;
                    const op = Object.assign(Object.assign({}, acc), { imageLinks: [link] });
                    return op;
                }
                case 'descriptionOverride': {
                    if (isAdmin) {
                        return acc;
                    }
                    const { valuesToOverride } = override;
                    const { description } = valuesToOverride;
                    const op = Object.assign(Object.assign({}, acc), { description });
                    return op;
                }
            }
        }
        return acc;
    }, product);
    const existingTags = newProduct.tags ? newProduct.tags : [];
    return Object.assign(Object.assign({}, newProduct), { tags: [...existingTags, ...activeTags] });
};
export default map;
